import React from "react";
import { Bar, Doughnut, Line, Pie } from "react-chartjs-2";
import zoom from 'chartjs-plugin-zoom'
import ReactStars from "react-rating-stars-component";
// import TableViewer from "../../components/TableViewer";
import { getBoundingClientRect } from "../utils/functions";
import TableViewer from "./TableViewer";
import Responsive from "./Responsive";
import FixedView from "./FixedView";
import { checkTranslation, translate } from "../utils/useful";



class ReportAll extends React.Component {
    state = {
        lineWidth: 40,
        show: true,
        // info: [
        //     { data: "Visits", numb: "0", color: "#4287f5" },
        //     { data: "Answered", numb: "0", color: "#f542f2" },
        //     { data: "Response rate", numb: "0%", color: "#feab32" },
        //     { data: "Average response time", numb: "00:00", color: "#32fe83" },
        // ],
        persons: [
            { name: "nastran javid", number: "10", improve: "20%", answer: "10/20" },
            { name: "reza salek", number: "15", improve: "40%", answer: "14/20" },
            { name: "faeze mohrechi", number: "12", improve: "90%", answer: "10/20" },
            { name: "parna azizi", number: "17", improve: "70%", answer: "17/20" }
        ],
        all: {
            name: "all",
            chart: [
                { img: '/assets/icons/line.svg', step: '0' },
                { img: '/assets/icons/Group 4.svg', step: '1' },
                { img: '/assets/icons/bar.svg', step: '2' },
                { img: '/assets/icons/rating.svg', step: '3' },
                { img: '/assets/icons/table.svg', step: '4' },
            ],
            colors: [
                { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
                { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
                { backgroundColor: '#90aaee', borderColor: '#90aaee20' },
                { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
                { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
                { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
            ]
        },
        people: ['nastran javid', 'reza salek', 'parna azizi', 'faeze mohrechi', 'all'],
        name: "all",
        chart: [
            { img1: '/assets/icons/line-green.svg', img2: '/assets/icons/line-gray.svg', step: '0' },
            { img1: '/assets/icons/bie-green.svg', img2: '/assets/icons/bie-gray.svg', step: '1' },
            { img1: '/assets/icons/bar-green.svg', img2: '/assets/icons/bar-gray.svg', step: '2' },
            { img1: '/assets/icons/rating-green.svg', img2: '/assets/icons/rating-gray.svg', step: '3' },
            { img1: '/assets/icons/table-green.svg', img2: '/assets/icons/table-gray.svg', step: '4' },
        ],
        data: {
            labels: [],
            datasets: []
        },
        chartOptions: {
            legend: { display: false },
            bezierCurve: false,
            zoom: {
                mode: 'xy',
                overScaleMode: 'y',
                modifierKey: 'shift',
                wheel: { enabled: false, modifierKey: 'shift', },
                drag: { enabled: true, modifierKey: 'shift', },
                pinch: { enabled: true, modifierKey: 'shift', },
            },
            scales: {
                xAxes: [
                    {
                        gridLines: { color: 'transparent', },
                        ticks: { beginAtZero: true, fontColor: '#afafaf', fontSize: 12, }
                    },
                ],
                yAxes: [
                    {
                        gridLines: { color: "#eeeeeeFF" },
                        ticks: { beginAtZero: true, fontColor: '#afafaf', fontSize: 12, }
                    },
                ],
            }
        },
        stepitem: '0'
    }


    // colors = [
    //     { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
    //     { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
    //     { backgroundColor: '#90AAEE', borderColor: '#90aaee20' },
    //     { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
    //     { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
    //     { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
    // ]

    backgroundColors = ['#f8fcb8', '#ffc8bd', '#dafaaa', '#abf9ff', '#ff0099']

    componentDidMount() {
        window.addEventListener('resize', this.getSize)
        this.getSize()

        this.createData()

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)

    }

    createData = () => {
        let labels = []
        let datasets = [{ data: [], backgroundColor: this.backgroundColors }]

        let scores = this.props.data?.scores
        // console.log(scores)
        if (scores) {

            for (const [key, value] of Object.entries(scores)) {
                // console.log(value)
                labels.push('Label ' + key)
                datasets[0].data.push(value)
            }

            let data = this.state.data
            data.datasets = datasets
            data.labels = labels
            // console.log(data)
            this.setState({ data, show: false }, () => {
                this.setState({ show: true })
            })
        }


    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }

    // handleChengeChart = (key, value) => {
    //     this.setState({ [key]: value })
    // }

    changePerson = (item) => {
        if (item == 'all') {
            this.setState({ name: 'all' })

        }
        else {
            this.setState({ name: item })
        }
    }
    render() {
        return (
            <div className="pb-2">
                <div className="w-100 " style={{ }}>
                    <div className="m-2">
                        <div>
                            <FixedView width={this.props.width} zIndex={10} ref={el => this.viewFixedView = el} nodeRef={this.viewNode} xOffset={50} topOffset={0} maxWidth={180} >
                                <div className=' box-shadow-20 br-10 p-2 bg-white'>
                                    {this.state.people.map((item, index) => {
                                        return (
                                            <div className="d-flex p-1 hover-person" onClick={() => this.changePerson(item)}>
                                                <div style={{ minWidth: 130 }}>
                                                    <p className="font-size-12 py-1 pld-1" >{checkTranslation(item)}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </FixedView>
                        </div>

                        <div>
                            {this.state.name == 'all' && (
                                <div className="p-4 shadow-2 bg-white br-10 w-100">
                                    <div className="mb-3 w-100 flexcb" style={{}}>
                                        <div className="d-flex">
                                            <p className="color-black font-size-14">{translate('Average score')}: {this.props.data.average}</p>
                                            <p className="color-black font-size-14">&nbsp; / &nbsp;</p>
                                            <p className="color-black font-size-14">{translate('Max score')}: {this.props.data.max}</p>
                                        </div>
                                        <div className="d-flex flexcc">
                                            {this.state.chart.map((data) => {
                                                return (
                                                    <div className="mrd-1 flex-1 flexcc" onClick={() => this.setState({ stepitem: data.step })} style={{ cursor: 'pointer', padding: '3px 9px', borderRadius: 7, transition: 'all .4s ease-in-out', }}>
                                                        <img src={this.state.stepitem == data.step ? data.img1 : data.img2} width={25} />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div className="px-2">
                                        {this.state.stepitem == '0' && (
                                            this.state.show && (
                                                <div ref={el => this.chartContainer = el} style={{}} className="col-12 p-0">
                                                    <Line data={this.state.data} options={this.state.chartOptions} ref={el => this.chart = el} height={'40%'} width={'100%'} plugins={[zoom]} borderColor={'#ee5050'} />
                                                </div>
                                            )
                                        )}
                                        {this.state.stepitem == '1' && (
                                            this.state.show && (
                                                <div ref={el => this.chartContainer = el} style={{}} className="col-12 p-3">
                                                    <Pie data={this.state.data} ref={el => this.chart = el} />
                                                </div>
                                            )
                                        )}
                                        {this.state.stepitem == '2' && (
                                            this.state.show && (
                                                <div ref={el => this.chartContainer = el} style={{}} className="col-12 p-3">
                                                    <Bar data={this.state.data} options={this.state.chartOptions} ref={el => this.chart = el} height={this.state.width > 500 ? '30%' : '100%'} width={'100%'} plugins={[zoom]} borderColor={'#ee5050'} />
                                                </div>
                                            )
                                        )}
                                        {this.state.stepitem == '3' && (
                                            this.state.show && (
                                                <div style={{}} className="col-12 p-3 flexc">
                                                    <div className="col-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <ReactStars count={5} size={30} edit={false} value={4.8} isHalf={true} color="#eee" activeColor="#ffcc00" />
                                                        <div>
                                                            <p style={{ fontSize: 40, fontWeight: '800' }}>4.8</p>
                                                        </div>
                                                        <div>
                                                            <p style={{ fontSize: 11 }}>out of 5</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-100 col-8" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                                        <div className="w-100 d-flex align-items-center ">
                                                            <div className="mrd-2">
                                                                <ReactStars count={5} size={20} edit={false} value={5} isHalf={true} color="#eee" activeColor="#d0d0d0" />
                                                            </div>
                                                            <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                                                <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-100 d-flex align-items-center ">
                                                            <div className="mrd-2">
                                                                <ReactStars count={5} size={20} edit={false} value={4} isHalf={true} color="#eee" activeColor="#d0d0d0" />
                                                            </div>
                                                            <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                                                <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-100 d-flex align-items-center ">
                                                            <div className="mrd-2">
                                                                <ReactStars count={5} size={20} edit={false} value={3} isHalf={true} color="#eee" activeColor="#d0d0d0" />
                                                            </div>
                                                            <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                                                <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-100 d-flex align-items-center ">
                                                            <div className="mrd-2">
                                                                <ReactStars count={5} size={20} edit={false} value={2} isHalf={true} color="#eee" activeColor="#d0d0d0" />
                                                            </div>
                                                            <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                                                <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                                            </div>
                                                        </div>
                                                        <div className="w-100 d-flex align-items-center ">
                                                            <div className="mrd-2">
                                                                <ReactStars count={5} size={20} edit={false} value={1} isHalf={true} color="#eee" activeColor="#d0d0d0" />
                                                            </div>
                                                            <div style={{ background: '#f5f5f5', width: '60%', height: '9px', borderRadius: 50 }}>
                                                                <div style={{ background: '#d0d0d0', width: '50%', height: '9px', borderRadius: '50px 0 0 50px' }}>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: 13, color: '#606060' }}>&nbsp;30%</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                        {this.state.stepitem == '4' && (
                                            this.state.show && (
                                                <div style={{}} className="col-12 p-3">
                                                    <TableViewer
                                                        headers={this.state.headers}
                                                        data={this.props.item}
                                                        ref={el => this.TableViewer = el}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>)
                            }
                            {this.state.persons.map((item, index) => {
                                return (
                                    <>
                                        {this.state.name == item.name && (
                                            <div className="mt-3 d-flex flex-wrap">
                                                <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '6' }} >
                                                    <div className="p-3 br-20 mrd-4" style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 15px -3px, rgba(0, 0, 0, 0.1) 1px 4px 6px -4px' }}>
                                                        <div className="flexcb">
                                                            <p className="font-size-15 weight-400 color-dark-blue-1">{translate('Homework')}</p>
                                                            <p className="font-size-12" style={{ color: "#7A7A7A" }}>{translate('Details')}</p>
                                                        </div>
                                                        <div ref={el => this.chartContainer = el} style={{}} className=" pt-3 flexcc">
                                                            <Doughnut data={this.state.data} />
                                                        </div>
                                                    </div>
                                                </Responsive>
                                                <Responsive width={this.props.width} media={{ xs: '12', sm: '6', md: '6' }} >
                                                    <div className="p-3 br-20" style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 15px -3px, rgba(0, 0, 0, 0.1) 1px 4px 6px -4px' }}>
                                                        <div className="flexcb">
                                                            <p className="font-size-15 weight-400 color-dark-blue-1">{translate('Mark')}:</p>
                                                            <p className="font-size-12" style={{ color: "#7A7A7A" }}>{translate('Details')}</p>
                                                        </div>
                                                        <div ref={el => this.chartContainer = el} style={{}} className="px-3 pt-2">
                                                            <Bar data={this.state.data} options={this.state.chartOptions} ref={el => this.chart = el} height={this.state.width > 500 ? '57%' : '100%'} width={'100%'} plugins={[zoom]} borderColor={'#ee5050'} />
                                                        </div>
                                                    </div>
                                                </Responsive>
                                                <div className="p-3 br-20 mt-3 w-100" style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 15px -3px, rgba(0, 0, 0, 0.1) 1px 4px 6px -4px' }}>
                                                    <div>
                                                        <p className="font-size-16 weight-600 color-dark-blue-1">{translate('The rate of improvement in the test')}</p>
                                                    </div>
                                                    <div className="flexcc flex-column w-100 px-1">
                                                        <div className="w-100 mt-3" style={{}}>
                                                            <div className="position-relative w-100 br-20" style={{ background: "#e6e6e6", height: "30px" }}>
                                                                <div className="position-absolute br-20" style={{ background: "#573BFF", height: "30px", width: this.state.lineWidth + '%' }}></div >
                                                                <p className="position-absolute font-size-12 mld-4 white" style={{ marginTop: "5px" }}>7{translate('question')} / 10{translate('min')} </p>
                                                            </div >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        }
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default ReportAll;